import api from "@/services/api";

export default {
  testKitList(params) {
    return api().post("user/master/test-kit/list", params);
  },
  howHeardList(params) {
    return api().post("user/master/how-heard/list", params);
  },
  clinicList(params) {
    return api().post("user/master/clinic/list", params);
  },
  programCodeSpecimenTypeList(){
    return api().post("user/master/program-code-specimen-type-list");
  },
  programCodeSpecimenTypeListNew(){
    return api().post("user/master/program-code-specimen-type-list-new");
  },
  check_user_race_list(params) {
    return api().get("user/master/check-user-race-list", params);
  },
};
